import { render, staticRenderFns } from "./PlatformStatementSummary.vue?vue&type=template&id=0b860d7f&"
import script from "./PlatformStatementSummary.vue?vue&type=script&lang=js&"
export * from "./PlatformStatementSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports